// extracted by mini-css-extract-plugin
export default {"GlobalSearchTarget":"index__GlobalSearchTarget__ZwLvz"};